<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-02-26 17:30:10
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-25 17:23:49
 * @Description: file content
 -->
<template>
  <div class="t9_map">
    <remote-script
      charset="utf-8"
      src="https://map.qq.com/api/js?v=2.exp&key=MDGBZ-JJD36-HBASY-M23ME-PRFZZ-BMFQP&callback=qqMapCallback"
    ></remote-script>
    <div id="t7MapMap" class="t7MapMap"></div>
    <div ref="refTabBlock">
      <div class="pi">
        <div class="pi_na">
          <div
            class="pi_name"
            v-if="pageInfo&&pageInfo.Extinfo&&pageInfo.Extinfo.buildingName"
          >{{pageInfo.Extinfo.buildingName}}</div>
          <div
            class="pi_addr"
            v-if="pageInfo&&pageInfo.Extinfo&&pageInfo.Extinfo.address"
          >{{pageInfo.Extinfo.address}}</div>
        </div>
        <div class="pi_nav">
          <img @click="clickNav" :src="mapIconSrc" />
        </div>
      </div>
      <div class="line"></div>
      <div class="around">
        <div
          class="around_item"
          :class="{active:item.index == selectedAround.index, ishf: isHuafa}"
          @click="clickAroundType(item)"
          v-for="item in aroundList"
        >{{item.name}}</div>
      </div>
    </div>
    <div class="line"></div>
    <div ref="refAddr" class="addr">
      <div
        class="addr_item"
        :class="{active:item.id==addrActiveId}"
        v-for="item in pois"
        @click="clickAddrItem(item)"
      >
        <div class="addr_order">
          <div class="addr_index">{{item.uiOrder}}</div>
        </div>
        <div class="addr_name">{{item.name}}，距离{{item.dist}}米</div>
      </div>
    </div>
    <!-- lj48 -->
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>

<script>
let that = null;
window.qqMapCallback = function() {
  let tmpInterval = setInterval(() => {
    if (that.isVueInitOk && document.getElementById("t7MapMap")) {
      that.initMap();
      clearInterval(tmpInterval);
    }
  }, 500);
};

import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
import wxsdk from "@/utils/wxsdk";
export default {
  components: { BtnBackLayout4 },
  props: {},
  data() {
    return {
      isVueInitOk: false,
      map: null,
      searchService: null,
      markers: [],
      pois: [],
      addrActiveId: "",
      aroundList: [
        {
          name: "交通",
          keyword: "公交",
          index: 0
        },
        {
          name: "教育",
          keyword: "学校",
          index: 1
        },
        {
          name: "医疗",
          keyword: "医院 ",
          index: 2
        },
        {
          name: "商户",
          keyword: "超市",
          index: 3
        }
      ],
      selectedAround: {
        name: "交通",
        keyword: "公交",
        index: 0
      },
      infoWin: null,
      isHuafa: util.checkIsHuafa(),
      mapIconSrc: "",
      isCustom: false
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
      "rsCardInfo"
    ])
  },
  methods: {
    clickNav() {
      if (this.isInMiniProgram) {
        wxsdk.wx.openLocation({
          latitude: parseFloat(this.pageInfo.Extinfo.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(this.pageInfo.Extinfo.lng), // 经度，浮点数，范围为180 ~ -180。
          name: this.pageInfo.Extinfo.buildingName, // 位置名
          address: this.pageInfo.Extinfo.address, // 地址详情说明
          scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
        });
      } else {
        util.openUrl(
          `http://uri.amap.com/marker?position=${this.pageInfo.Extinfo.lng},${this.pageInfo.Extinfo.lat}&name=${this.pageInfo.Extinfo.buildingName}`
        );
      }
    },
    // 点击周边类型
    clickAroundType(item) {
      if (this.infoWin) {
        this.infoWin.close();
      }
      //获取选择的附近关键词，同时更新状态
      this.selectedAround = item;
      this.getAround();
    },
    // 获取周边信息
    getAround() {
      if (this.isCustom) {
        console.log("自定义周边>>>");
        this.afterSearchService(this.getCustomPois(this.selectedAround.index));
      } else {
        var region = new qq.maps.LatLng(
          this.pageInfo.Extinfo.lat,
          this.pageInfo.Extinfo.lng
        );
        this.searchService.searchNearBy(
          this.selectedAround.keyword,
          region,
          2000
        );
      }
    },
    afterSearchService(pois) {
      console.log("pois》》》", JSON.parse(JSON.stringify(pois)));
      this.pois = pois.map((item, index) => {
        item.uiOrder = index + 1;
        return item;
      });
      if (pois) {
        that.infoWin = new qq.maps.InfoWindow({
          map: that.map
        });
        var latlngBounds = new qq.maps.LatLngBounds();
        var iconurl = "";
        for (var i = 0, l = pois.length; i < l; i++) {
          var poi = pois[i];
          //扩展边界范围，用来包含搜索到的Poi点
          latlngBounds.extend(poi.latLng);
          (function(n) {
            if (that.isHuafa) {
              iconurl = `https://assets.rurushishi.com/yq-rs-make/huafa/location.png?x-oss-process=image/resize,h_30,w_30`;
            } else {
              iconurl = `https://assets.wxmp.ruthus.com/rushixcx/map_pos-order/${n +
                1}.png?x-oss-process=image/resize,h_30,w_30`;
            }
            var marker = new qq.maps.Marker({
              map: that.map
            });
            marker.setPosition(pois[n].latLng);
            var anchor = new qq.maps.Point(10, 30),
              size = new qq.maps.Size(30, 30),
              origin = new qq.maps.Point(0, 0),
              icon = new qq.maps.MarkerImage(
                `${iconurl}`,
                size,
                origin,
                anchor
              );
            marker.setIcon(icon);

            that.markers.push(marker);

            qq.maps.event.addListener(marker, "click", function() {
              that.infoWin.open();
              that.infoWin.setContent(
                `<div style="width:150px;height:50px;">${pois[n].name}${
                  pois[n].dist ? "<br/>距离" + pois[n].dist + "米" : ""
                }</div>`
              );
              that.infoWin.setPosition(pois[n].latLng);
            });
          })(i);
        }
        //调整地图视野
        that.map.fitBounds(latlngBounds);
      }
    },
    clickAddrItem(pois) {
      this.addrActiveId = pois.id;
      if (this.infoWin) {
        this.infoWin.close();
        this.infoWin.setContent(
          `<div style="width:150px;height:50px;">${pois.name}${
            pois.dist ? "<br/>距离" + pois.dist + "米" : ""
          }</div>`
        );
        this.infoWin.setPosition(pois.latLng);
        this.infoWin.open();
      }
    },
    //清除地图上的marker
    clearOverlays(overlays) {
      var overlay;
      while ((overlay = overlays.pop())) {
        overlay.setMap(null);
      }
    },
    initMap() {
      let that = this;
      if (
        // false &&
        that.pageInfo.Extinfo.aroundListInfo &&
        that.pageInfo.Extinfo.aroundListInfo[0].list &&
        that.pageInfo.Extinfo.aroundListInfo[0].list.length > 0
      ) {
        that.isCustom = true;
      }
      let t7MapMapHeight = document.documentElement.clientHeight / 2;
      document.getElementById("t7MapMap").style.height = t7MapMapHeight + "px";
      this.$refs.refAddr.style.height =
        t7MapMapHeight - this.$refs.refTabBlock.offsetHeight + "px";

      var centerLatLng = new qq.maps.LatLng(
        this.pageInfo.Extinfo.lat,
        this.pageInfo.Extinfo.lng
      );
      var map = new qq.maps.Map(document.getElementById("t7MapMap"), {
        center: centerLatLng,
        zoom: 13
      });
      this.map = map;
      var centerMarker = new qq.maps.Marker({
        position: centerLatLng,
        map: map
      });
      /**
       * 设置Marker自定义图标的属性，
       * size是图标尺寸，该尺寸为显示图标的实际尺寸，
       * origin是切图坐标，该坐标是相对于图片左上角默认为（0,0）的相对像素坐标，
       * anchor是锚点坐标，描述经纬度点对应图标中的位置
       */
      var anchor = new qq.maps.Point(10, 30),
        size = new qq.maps.Size(30, 30),
        origin = new qq.maps.Point(0, 0),
        icon = new qq.maps.MarkerImage(
          "http://assets.wxmp.ruthus.com/rushixcx/map_center.png?x-oss-process=image/resize,h_30,w_30",
          size,
          origin,
          anchor
        );
      centerMarker.setIcon(icon);
      var centerLabel = new qq.maps.Label({
        position: centerLatLng,
        map: map,
        content: this.pageInfo.Extinfo.buildingName
      });
      // 自定义周边
      if (that.isCustom) {
        that.aroundList = that.pageInfo.Extinfo.aroundListInfo.map(
          (item, index) => {
            item.index = index;
            return item;
          }
        );
      } else {
        //设置Poi检索服务，用于本地检索、周边检索
        this.searchService = new qq.maps.SearchService({
          //检索成功的回调函数
          complete: function(results) {
            if (results && results.detail && results.detail.pois) {
              that.afterSearchService(results.detail.pois, map);
            }
          },
          //若服务请求失败，则运行以下函数
          error: function() {
            // alert("出错了。");
            location.reload();
          }
        });
        this.searchService.setPageCapacity(20);
      }
      // 第一次查询
      this.getAround();
    },
    getCustomPois(index) {
      // 选取第一个元素
      let newPois = that.pageInfo.Extinfo.aroundListInfo[index].list.map(
        item => {
          // var myLatLng = new qq.maps.LatLng(item.location.lat, item.location.lng);
          let newItem = {
            latLng: new qq.maps.LatLng(item.location.lat, item.location.lng),
            id: item.id,
            name: item.title,
            address: item.address,
            phone: "",
            postcode: "",
            category: item.category,
            dist: item._distance,
            type: item.type
          };
          return newItem;
        }
      );
      return newPois;
    }
  },
  created() {
    that = this;
    util.checkMapStateCallback(that, ["pageInfo"]).then(() => {
      this.isVueInitOk = true;
      if (this.isHuafa) {
        this.mapIconSrc =
          "https://assets.rurushishi.com/yq-rs-make/huafa/map_nav2.png";
      } else {
        this.mapIconSrc = "http://assets.wxmp.ruthus.com/rushixcx/map_nav2.png";
      }
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.t7MapMap {
  width: 100%;
  /* height: 5rem; */
}

.line {
  width: 100%;
  border-bottom: 1px solid #f4f4f4;
}
.pi {
  display: flex;
}

.pi_na {
  width: 80%;
  padding: 0.3rem;
}

.pi_name {
  color: #212121;
  font-size: 0.32rem;
  font-weight: 600;
}

.pi_addr {
  font-size: 0.24rem;
  padding-top: 0.2rem;
  color: #8c8c8c;
}

.pi_nav {
  width: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pi_nav > img {
  /* width: 90rpx;
  height: 90rpx; */
  width: 0.9rem;
  height: 0.9rem;
  /* box-shadow: 0px 5px 5px #007ca6; */
}

.around {
  width: 100%;
  font-size: 0;
  background-color: #fff;
}

.around_item {
  display: inline-block;
  width: 25%;
  overflow: hidden;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  font-size: 0.3rem;
  color: #333;
}

.around_item.active {
  color: #007da6;
  border-radius: 5px;
}

.addr {
  overflow: scroll;
}

.addr_item {
  height: 0.8rem;
  padding: 0.2rem;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
}

.addr_order {
  width: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 0.1rem;
}

.addr_index {
  background-color: #007da6;
  border-radius: 50%;
  width: 0.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  color: #fff;
}

.addr_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 0.8rem;
  line-height: 0.8rem;
}

.addr_item.active {
  background-color: #498fe2;
}

.addr_item.active .addr_index {
  background-color: #498fe2;
  border: 1px solid #fff;
  color: #fff;
}

.addr_item.active .addr_name {
  color: #fff;
}
</style>